import React from "react";
import HaqtInput from "../../components/HaqtInput/HaqtInput";
import * as yup from "yup";
import { useFormik } from "formik";
import { postRequest } from "../../utils/api";
import queryString from "query-string";
import { useNavigate } from "react-router-dom";
import { notifyError, notifySuccess } from "../../components/Toaster/Toaster";
import lockImg from "../../assests/img/lockImg.png";
import "./resetpassword.scss";

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(.{8,})$/;
const validationSchema = yup.object({
  password: yup
    .string()
    .min(8, "Password should be of minimum 8 characters length")
    .matches(
      passwordRegex,
      "Password must contain at least one uppercase letter, one lowercase letter,a special character and a number",
    )
    .required("Password is required"),
  confirm: yup
    .string()
    .required("Retype Password is required")
    .oneOf([yup.ref("password"), null], "Password input doesn't match"),
});

const ResetPassword = () => {
  const params = queryString.parse(window.location.search, { decode: false });
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      password: "",
      confirm: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      delete values.confirm;
      values.email = params?.email;
      loginHandler(values);
    },
  });

  const loginHandler = async (values) => {
    try {
      values.token = params?.token;
      const response = await postRequest("/Account/ResetPassword", values);
      if (response && response.data && response.data.isSuccess) {
        notifySuccess("Password reset successfully");
        formik.resetForm();
        navigate("/auth/login"); //Dheeraj Edit
      }
    } catch (error) {
      notifyError(error);
    }
  };

  return (
    <>
      <div>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <HaqtInput
              fullWidth
              id="password"
              name="password"
              className="focus-placeholder"
              placeholder="Password"
              type="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              icon={<img src={lockImg} height={17} width={20} />}
            />
          </div>
          <div className="mb-3">
            <HaqtInput
              fullWidth
              id="confirm"
              name="confirm"
              className="focus-placeholder"
              placeholder="Retype Password"
              type="password"
              value={formik.values.confirm}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.confirm && Boolean(formik.errors.confirm)}
              helperText={formik.touched.confirm && formik.errors.confirm}
              icon={<img src={lockImg} height={17} width={20} />}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary "
            style={{
              width: "100%",
              borderRadius: "25px",
              background: "#022C31",
              borderColor: "#022C31",
              marginBottom: "5rem",
            }}
          >
            Reset Password
          </button>
        </form>
      </div>
    </>
  );
};

export default ResetPassword;
